import Api from "../apiService";

class OrderInvoicesApi {
  index(companyId, orderId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/invoices`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, orderId, id) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, orderId, data) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/invoices`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, orderId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}/invoices/${id}`,
      data,
      Api.authHeaders()
    );
  }
}

export default new OrderInvoicesApi();
